import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import OpenAI from "openai";
import { Button, Modal } from "antd";

const backend = process.env.REACT_APP_BACKEND;
const openai = new OpenAI({
  apiKey: process.env.REACT_APP_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true 
})

function CountdownCounter({row, sourceDataKorHandler}) {
    const [count, setCount] = useState(0);
    const [isGo, setIsGo] = useState([0,0])
    const stopRef = useRef(false)

    const countHandler = (e) => {
      e.stopPropagation();
      setIsGo([1,0])
      createSentenceBySDK(row)
    }

    const stopHandler = (e) => {
      e.stopPropagation()
      setIsGo([0,0])
      setCount(0)
      stopRef.current = true
      // 중지 시 진행되는 로직 추가
    }

    const createSentenceBySDK = async (row) => {
      stopRef.current = false
      const subUnitCode = row.code
      const prompt_text = row.prompt_text
      const model = row.model || "gpt-3.5-turbo"

      try{
        const chatCompletion = await openai.chat.completions.create({
          model: model,
          temperature: 1,
          messages: 
            [
              // {
              //   "role": "system",
              //   "content": "List only sentences in array format"
              // },
              {
                "role": "user",
                "content": prompt_text
              },
            ],
            tools: [
              {
                "type": "function",
                "function": {
                  "name": "get_sentence",
                  "description": "get english and korean sentences",
                  "parameters": {
                      "type": "object",
                      "properties": {
                          "props": {
                              "type": "array",
                              "items": {
                                  "type": "object",
                                  "properties": {
                                      "english": { "type": "string", "description": "english sentence" },
                                      "korean": { "type": "string", "description": "english to korean" }
                                  }
                              }
                          }
                      },
                      "required": ["props"]
                      }
                },
            }
            ]
        });

        const newSentence = JSON.parse(chatCompletion.choices[0].message.tool_calls[0].function.arguments).props
        console.log("Generated by " + chatCompletion.model + " at " + subUnitCode)
        console.log(newSentence)
        if(!stopRef.current) {

          axios.post(`${backend}/contents/content_sentence/ai/gpt/list2/${subUnitCode}`,{newSentence})
          .then(res=>{
            const sentenceCount = res.data.data.length
            sourceDataKorHandler(sentenceCount, row.num)
            setIsGo([0,1])
            setCount(0)
          })
          .catch(err=>{
            setIsGo([0,0])
            setCount(0)
            Modal.error({
              title:"DB저장 에러",
              okText:"확인",
              content:"DB에 저장하지 못했습니다. 관리자에게 문의하세요."
            })
          })
        }
      } catch (error) {
        if (error instanceof OpenAI.APIError) {
          console.error(error.status);  // e.g. 401
          console.error(error.message); // e.g. The authentication token you passed was invalid...
          console.error(error.code);  // e.g. 'invalid_api_key'
          console.error(error.type);  // e.g. 'invalid_request_error'

          setIsGo([0,0])
          setCount(0)
        } else {
          // Non-API error
          console.log(error);
          setIsGo([0,0])
          setCount(0)
        }
      }

    }
    

    useEffect(() => {
      let interval

      if(isGo[0] === 1) {
        interval = setInterval(() => {
          if (isGo[0] === 1) {
            setCount(count + 1);
          }
        }, 1000);
      }
        
      return () => {
        clearInterval(interval);
      };
    }, [count, isGo]);
  
    return (
      <div>
        {
          isGo[0] === 0
          ? <Button onClick={(e)=>countHandler(e)} disabled={!row.prompt_text}>생성</Button>
          : <Button onClick={(e)=>stopHandler(e)} disabled>중지</Button>
        }
        <span style={{marginLeft:"5px"}}>
          {
            isGo[0] === 1
            ? count 
            : isGo[1] === 1
            ? "완료"
            : null
          }
        </span>
      </div>
    )
  }

  export default CountdownCounter